import {
  OrderTrackingIntegrationType,
  OrderTrackingOrderStatus,
  OrderTrackingShipmentStatus,
} from "@redotech/redo-model/order-tracking/order-tracking-types";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const platformSchema = z.enum(["redo", "malomo"]);

const integrationSchema = z.nativeEnum(OrderTrackingIntegrationType);
const orderStatusSchema = z.nativeEnum(OrderTrackingOrderStatus);
const shipmentStatusSchema = z.nativeEnum(OrderTrackingShipmentStatus);

const eventTypeSchema = z.union([orderStatusSchema, shipmentStatusSchema]);

export const sendIntegrationEventTest = {
  name: "sendIntegrationEventTest" as const,
  input: z.object({
    teamId: zExt.objectId(),
    platform: platformSchema,
    integration: integrationSchema,
    eventType: eventTypeSchema,
    orderIdentifier: z.string().optional(),
    testEmail: z.string().optional(),
    testPhoneNumber: z.string().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    error: z.string().nullable(),
    message: z.string().optional(),
  }),
};
